import React, { useState, useEffect } from 'react';
import sparkles from '../../assets/icons8-sparkle-24.png';
import { useAuth } from '../../contexts/AuthContext';
import { generateCopyWithVoice } from '../../clients/copyClient';
import SpeechToText from './speech-to-text';

export default function VoiceCopyForm({ updateCopy, email, credits, setOpenSubscriptionModal, showCopyNotification, setSelectedTool }) {
    const [isLoading, setIsLoading] = useState(false);
    const { authToken } = useAuth();

    const generate = async (event) => {
        if (credits > 0) {
            localStorage.setItem('type', 'generic-voice')
            try {
                setIsLoading(true);
                const copy = await generateCopyWithVoice(email, authToken, 'generic-voice');
                updateCopy(copy);
            } catch (error) {
                console.error('Failed to fetch:', error);
            } finally {
                setIsLoading(false);
            }
        } else {
            setOpenSubscriptionModal(true);
        }
    };

    return (
        <>
            <div>
                <SpeechToText generate={generate} isLoading={isLoading}/>
            </div>
            <div className={`w-full flex flex-col sm:flex-row justify-between space-x-4 text-start sm:text-end`}>
                <div className="flex space-x-4 mb-3 sm:mb-0">
                    
                </div>
            </div>
            <button className='text-custom-orange mt-2 font-bold' onClick={() => setSelectedTool('generic')}><u>want to type it out instead?</u></button>
        </>
    );
}
